<template>
    <div class="site-navbar">
        <div class="row container">

  <el-menu default-active="1"  mode="horizontal" :router="true" @select="handleSelect">

    <el-submenu index="a" class="">
        <template slot="title">Informazioni Generali</template>
        <el-menu-item index="/inside/info-generali/citta" class="font-color-e">Città di Napoli</el-menu-item>
        <el-menu-item index="/inside/info-generali/sede" class="font-color-e">Sede del congresso</el-menu-item>
        <el-menu-item index="/inside/info-generali/premi" class="font-color-e">Premi</el-menu-item>
        <el-menu-item index="/inside/info-generali/ecm" class="font-color-e">ECM</el-menu-item>
    </el-submenu>

    <el-submenu index="b" class="">
        <template slot="title">Iscrizioni</template>
        <el-menu-item index="inside/info-generali/quote" class="font-color-e">Modalità di iscrizione</el-menu-item>
        <el-menu-item index="iscrizioni" class="font-color-e">Iscrizioni</el-menu-item> 
        <el-menu-item index="iscrizioni" class="font-color-e">Iscrizioni Aziendali</el-menu-item>
    </el-submenu>

    <el-menu-item index="/inside/comitati/comitati" class="">Comitati</el-menu-item>

    <el-submenu index="c" class="">
        <template slot="title">Programma</template>
        <el-menu-item index="inside/programma/presto-disponibile" class="font-color-c">Presto disponibile</el-menu-item>
    </el-submenu>

    <el-menu-item index="/inside/info-generali/prenotazione-alberghiera" class="">Prenotazione Alberghiera</el-menu-item>


    <el-submenu index="f" class="">
        <template slot="title">Aziende</template>
        <el-menu-item index="/inside/aziende/sponsor" class="font-color-e">Sponsor</el-menu-item>
        <el-menu-item index="iscrizioni" class="font-color-e">Iscrizioni</el-menu-item>
    </el-submenu>
</el-menu> 
        </div>
    </div>
</template>

<script>
export default {
  name: 'site-navbar',
  created () {
    console.log("Created Site-logged.vue")
  },
  methods: {
    handleSelect(key, keyPath) {
        if(keyPath=='/sezione/2/'){
            
        }
        else if(keyPath=='/page/f/4'){
           
        }
        else {
            
        }

        console.log()
        

    }
  }
}
</script>

<style>
.site-navbar{
    background: #3C4C55;
    height:52px;
}.site-navbar ul.el-menu{
    background: transparent;
    
    
}.site-navbar li, .site-navbar .el-submenu .el-submenu__title, .site-navbar .el-submenu .el-submenu__icon-arrow{
    color:#ffffff;
    font-size:1.3rem;
    padding:0;
    text-align:center;
    line-height:52px;
    height:52px;
    border:none !important;
    
}.site-navbar .el-menu-item, .site-navbar .el-submenu{
    width: 203px;
    color:#ffffff;
    font-size:1.3rem;
    border-bottom:none !important;
    line-height:52px;
    height:52px;
}li.el-menu-item:last-child{
    margin:0;    
}.site-navbar .el-menu-item:hover, .site-navbar .el-submenu:hover , .site-navbar .el-submenu:hover .el-submenu__title:hover{
    color:#ffffff;
    border-bottom:darkred;
    background-color: darkred;
}.site-navbar .el-submenu .el-menu-item{
    color:#ffffff;
    background-color: darkred;
    padding:0 10px;
    text-align:left;
    width: auto !important;
    margin:0;
}.el-menu--horizontal>.el-menu-item:hover, .el-menu--horizontal>.el-submenu.is-active .el-submenu__title, .el-menu--horizontal>.el-submenu:hover .el-submenu__title{
    border-bottom:none !important;
}.el-menu--horizontal .el-submenu>.el-menu{
    top:52px;
    padding:0;
    border:none;
    border-radius: none;


}
</style>


// WEBPACK FOOTER //
// Site-navbar.vue?6e667ea9